import type { TFunction } from 'i18next';
import type { ProjectsListColumn, ProjectsListMobileFilter, ProjectsListSort } from '../components/ProjectsListTable';
import { formatLastActivity, lastActivityTime } from './lastActivity';

/** "Senast uppdaterad" is the column every project list opens sorted by. */
export const LAST_ACTIVITY_FIELD = 'lastActivityAt';
export const DEFAULT_PROJECT_LIST_SORT: ProjectsListSort = { field: LAST_ACTIVITY_FIELD, direction: 'desc' };

export function lastActivityColumn<T extends { lastActivityAt?: string | null }>(t: TFunction): ProjectsListColumn<T> {
  return {
    field: LAST_ACTIVITY_FIELD,
    label: t('projects.columns.lastActivityAt'),
    filter: 'none',
    defaultSortDirection: 'desc',
    sortValue: row => lastActivityTime(row.lastActivityAt),
    render: row => formatLastActivity(row.lastActivityAt, t),
  };
}

/** The sort choices on mobile, where there are no column headers to click.
 *  Admin sorts project numbers within each company. */
export function projectListMobileSort(t: TFunction, admin = false): NonNullable<ProjectsListMobileFilter['sort']> {
  return {
    label: t('projects.sort.label'),
    options: [
      { field: LAST_ACTIVITY_FIELD, direction: 'desc', label: t('projects.sort.lastActivityNewest') },
      { field: LAST_ACTIVITY_FIELD, direction: 'asc', label: t('projects.sort.lastActivityOldest') },
      admin
        ? { field: 'companyName', direction: 'asc', label: t('projects.sort.companyAndNumber') }
        : { field: 'projectNumber', direction: 'asc', label: t('projects.sort.projectNumber') },
      { field: 'description', direction: 'asc', label: t('projects.sort.descriptionAZ') },
    ],
  };
}

/** A project with the stored status Avslutat. It is listed only under
 *  "Avslutade Projekt", and every other project only in the project list. */
export const isCompletedProject = (project: { status?: string | null }) => project.status === 'completed';
